import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import Routes from './Routes';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
